import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { requestOneUsersIdentification } from "../actions/users";
import { hasProyectByClienteId } from "../actions/consulSteel";
import { requestCantInCarrito } from "../actions/presupuesto";
import { requestProductosAllSearch } from "../actions/producto";
import logo from "../assets/images/Barbieri-MarcaGrafica-01.png";
import rutas from "../routes/constants/routes";
import colores from "../shared/constants/styles";
import MyUserService from "../services/myUser";
import SearchBar from "../utils/SearchBar";
import MenuIco from "../assets/icons/menu.svg";
import MenuNovedades from "../pages/commons/menu-items/novedades";
import MenuPerfil from "../pages/commons/menu-items/perfil";
import MenuFavoritos from "../pages/commons/menu-items/favoritos";
import { Usuario } from "./interface/IUsuario";
import "./header.css";

/* =========================================================
   TYPES
========================================================= */

interface MenuItem {
  id: number;
  nombre: string;
  link: string;
  menuPadreId: number | null;
  isExternal?: boolean;
  download?: boolean;
  redirect?: boolean;
  icon?: string | null;
}

interface MyUser {
  ultimoLogin?: string | null;
  email?: string | null;
  tipoRol?: number | null;
  bussinessName?: string | null;
  userName?: string | null;
  userId?: number | null;
  identificationId?: number | null;
  documentoNro?: string | null;
  contactoId?: number | null;
  clienteId?: number | null;
  menus?: {
    $values?: MenuItem[];
  } | null;
}

interface HeaderStateProps {
  hasproject: boolean;
  hasproject_success: boolean;
  cantidad: number;
  session: unknown;
  user: unknown;
  success: boolean;
  success_productos: boolean;
  productos: unknown[];
}

interface HeaderDispatchProps {
  requestCantInCarrito: (
    contactoId?: number | null,
    clienteId?: number | null,
  ) => void;

  requestOneUsersIdentification: (identificationData: unknown) => void;

  requestProductosAllSearch: (
    search: string,
    clienteId?: number | null,
    contactoId?: number | null,
  ) => void;

  hasProyectByClienteId: (clienteId?: number | null) => void;
}

type HeaderProps = HeaderStateProps & HeaderDispatchProps;

/* =========================================================
   COMPONENT
========================================================= */

const Header = (props: HeaderProps) => {
  const history = useHistory();
  const dropdownRef = useRef<HTMLUListElement | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [search, setSearch] = useState<boolean>(false);
  const [navOpen, setNavOpen] = useState<boolean>(true);
  const [showConsulsteelMenu, setShowConsulsteelMenu] =
    useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);

  const myUser = MyUserService.getMyUser() as MyUser | null;

  const menu: MenuItem[] = myUser?.menus?.$values ?? [];

  const menuPadre = menu.filter((m: MenuItem) => m.menuPadreId === null);

  const menuHijo = menu.filter((m: MenuItem) => m.menuPadreId !== null);

  const usuario: Usuario = {
    ultimoIngreso: myUser?.ultimoLogin,
    email: myUser?.email,
    nombre:
      myUser?.tipoRol === 1
        ? "Administrador"
        : myUser?.bussinessName !== null
        ? myUser?.bussinessName
        : myUser?.userName,
    Id: myUser?.userId,
    identificationId: myUser?.identificationId,
    numeroDoc: myUser?.documentoNro,
    tipoRol: myUser?.tipoRol,
  };

  /* =========================================================
     HANDLERS
  ========================================================= */

  const downloadFile = (link: string, nombre: string): void => {
    setSuccess(true);

    const fileName = `${nombre}.zip`;

    try {
      const a = document.createElement("a");

      a.href = link;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    } finally {
      setSuccess(false);
    }
  };

  const handleClick = (m: MenuItem, h: MenuItem): void => {
    if (h.download) {
      downloadFile(h.link, h.nombre.trim());

      return;
    }

    if (h.redirect) {
      window.open(h.link, "_blank", "noopener,noreferrer");
      return;
    }

    const newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/#" +
      m.link +
      h.link;

    window.history.pushState({ path: newurl }, "", newurl);

    window.location.reload();
  };

  const handleSearch = (searchValue: string): void => {
    setSearch(true);
    debugger;
    props.requestProductosAllSearch(
      searchValue,
      myUser?.clienteId,
      myUser?.contactoId,
    );
  };

  /* =========================================================
     EFFECTS
  ========================================================= */

  useEffect(() => {
    props.requestCantInCarrito(myUser?.contactoId, myUser?.clienteId);
  }, [props.success]);

  useEffect(() => {
    props.hasProyectByClienteId(myUser?.clienteId);
  }, []);

  /*
   * Ajusta la posición de los dropdowns de Bootstrap
   * para evitar que se salgan de la pantalla.
   */
  useEffect(() => {
    const fixDropdownPosition = (event: Event): void => {
      const toggle = event.target as HTMLElement | null;

      if (!toggle) {
        return;
      }

      const dropdownMenu = toggle.nextElementSibling as HTMLElement | null;

      if (!dropdownMenu || !dropdownMenu.classList.contains("dropdown-menu")) {
        return;
      }

      dropdownMenu.style.left = "";
      dropdownMenu.style.right = "";
      dropdownMenu.style.transform = "";

      requestAnimationFrame(() => {
        const rect = dropdownMenu.getBoundingClientRect();

        const viewportWidth = window.innerWidth;

        if (rect.left < 0) {
          dropdownMenu.style.left = "0";
          dropdownMenu.style.right = "auto";
          dropdownMenu.style.transform = "none";
        } else if (rect.right > viewportWidth) {
          dropdownMenu.style.left = "auto";
          dropdownMenu.style.right = "0";
          dropdownMenu.style.transform = "none";
        }
      });
    };

    document.addEventListener("show.bs.dropdown", fixDropdownPosition);

    return () => {
      document.removeEventListener("show.bs.dropdown", fixDropdownPosition);
    };
  }, []);

  useEffect(() => {
    if (props.success_productos) {
      setSearch(false);
      setSearchTerm("");

      history.push(
        `/allProductsList/${encodeURIComponent(
          JSON.stringify(props.productos),
        )}`,
      );

      setSuccess(false);
    }
  }, [props.success_productos, props.productos, history]);

  useEffect(() => {
    if (props.hasproject && props.hasproject_success) {
      setShowConsulsteelMenu(true);
    }
  }, [props.hasproject, props.hasproject_success]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <>
      <div
        style={{
          background: colores.rojo,
          padding: "1rem",
          width: "100%",
        }}
      >
        {myUser ? (
          <div>
            <div
              className="fluid"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                textDecoration: "none",
                color: "white",
                width: "100%",
                marginRight: "3rem",
              }}
            >
              {usuario.ultimoIngreso ? (
                <p
                  style={{
                    fontSize: "12px",
                    paddingInlineEnd: "4rem",
                    marginBottom: "0rem",
                  }}
                >
                  Último acceso: {usuario.ultimoIngreso}
                </p>
              ) : (
                <p
                  style={{
                    fontSize: "12px",
                    paddingInlineEnd: "4rem",
                    marginBottom: "0rem",
                  }}
                >
                  Bienvenido/a
                </p>
              )}
            </div>

            <nav
              className="navbar navbar-expand-lg static-top header__nav-container"
              style={{
                padding: "0rem",
              }}
            >
              <div
                className="fluid"
                style={{
                  justifyContent: "space-between",
                  padding: "0rem",
                  width: "100%",
                  margin: "0rem 3.5rem",
                }}
              >
                <div className="row">
                  <div className="col-2">
                    <Link
                      className={
                        navOpen
                          ? "navbar-brand header__nav-logo"
                          : "navbar-brand"
                      }
                      to={rutas.DASHBOARD}
                    >
                      <img src={logo} alt="Barbieri logo" height="36" />
                    </Link>

                    <img
                      className="header__ico-menu"
                      src={MenuIco}
                      alt="Menu"
                      onClick={() => setNavOpen(!navOpen)}
                    />
                  </div>

                  <div className="col-10">
                    <SearchBar
                      search={search}
                      success={success}
                      onSearch={handleSearch}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                </div>

                <div
                  className={
                    navOpen
                      ? "collapse.show navbar-collapse"
                      : "collapse navbar-collapse"
                  }
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav ms-auto" ref={dropdownRef}>
                    {menuPadre.map((m) =>
                      menuHijo.some((mh) => mh.menuPadreId === m.id) ? (
                        <li
                          key={m.id}
                          className="nav-item dropdown my-auto"
                          style={{
                            marginRight: "1.1rem",
                          }}
                        >
                          <button
                            type="button"
                            className="nav-link dropdown-toggle"
                            style={{
                              textDecoration: "none",
                              color: "white",
                              background: "transparent",
                              border: "none",
                              padding: "8px 0",
                            }}
                            onClick={() =>
                              setOpenMenuId(openMenuId === m.id ? null : m.id)
                            }
                            aria-expanded={openMenuId === m.id}
                          >
                            {m.nombre}
                          </button>

                          <ul
                            className={`dropdown-menu dropdown-menu-end ${
                              openMenuId === m.id ? "show" : ""
                            }`}
                            style={{
                              backgroundColor: colores.rojo,
                              maxHeight: 550,
                            }}
                          >
                            {menuHijo.map(
                              (h) =>
                                h.menuPadreId === m.id && (
                                  <li className="list-item" key={h.id}>
                                    {h.icon && (
                                      <img
                                        src={
                                          require(`../assets/icons/${h.icon}`)
                                            .default
                                        }
                                        alt="Icono"
                                        className="icon"
                                      />
                                    )}

                                    <Link
                                      className="children-link dropdown-item"
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleClick(m, h);
                                        setOpenMenuId(null);
                                      }}
                                    >
                                      {h.nombre}
                                    </Link>
                                  </li>
                                ),
                            )}
                          </ul>
                        </li>
                      ) : m.isExternal ? (
                        <li
                          key={m.id}
                          className="nav-item dropdown my-auto"
                          style={{
                            marginRight: "1.3rem",
                          }}
                        >
                          <a
                            href={m.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "white",
                              padding: "8px 0",
                            }}
                          >
                            {m.nombre}
                          </a>
                        </li>
                      ) : (
                        <li
                          key={m.id}
                          className="nav-item dropdown my-auto"
                          style={{
                            marginRight: "1.3rem",
                          }}
                        >
                          <Link
                            to={m.link}
                            style={{
                              textDecoration: "none",
                              color: "white",
                              padding: "8px 0",
                            }}
                          >
                            {m.nombre.trim() === "Carrito" ? (
                              <span>
                                Carrito
                                <span
                                  style={
                                    props.cantidad === 0
                                      ? {}
                                      : {
                                          borderRadius: "50%",
                                          padding: "0.2em 0.58em",
                                          marginLeft: "0.3rem",
                                          border: "1px solid white",
                                        }
                                  }
                                >
                                  {props.cantidad === 0 ? "" : props.cantidad}
                                </span>
                              </span>
                            ) : (
                              m.nombre
                            )}
                          </Link>
                        </li>
                      ),
                    )}
                    {showConsulsteelMenu && (
                      <li
                        className="nav-item dropdown my-auto"
                        style={{
                          marginRight: "1.3rem",
                        }}
                      >
                        <Link
                          style={{
                            textDecoration: "none",
                            color: "white",
                            padding: "8px 0",
                          }}
                          to={rutas.CONSUL_STEEL}
                        >
                          consulsteel
                        </Link>
                      </li>
                    )}
                    <MenuNovedades />
                    <MenuFavoritos />
                    <MenuPerfil usuario={usuario} />
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        ) : (
          <nav
            className="navbar navbar-expand-lg static-top"
            style={{
              padding: "1rem",
            }}
          >
            <div
              className="fluid"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0rem",
                width: "100%",
                margin: "0rem 2rem",
              }}
            >
              <Link className="navbar-brand" to={rutas.DASHBOARD}>
                <img src={logo} alt="Barbieri logo" height="36" />
              </Link>
            </div>
          </nav>
        )}
      </div>
    </>
  );
};

/* =========================================================
   REDUX
========================================================= */

const mapStateToProps = (state: any): HeaderStateProps => ({
  hasproject: state.consulsteel.hasproject,
  hasproject_success: state.consulsteel.success,
  cantidad: state.presupuestos.cantidad,
  session: state.users.session,
  user: state.users.user,
  success: state.presupuestos.success,
  success_productos: state.producto.success,
  productos: state.producto.productos,
});

const mapDispatchToProps = (dispatch: any): HeaderDispatchProps => ({
  requestCantInCarrito: (contactoId, clienteId) =>
    dispatch(requestCantInCarrito(contactoId, clienteId)),

  requestOneUsersIdentification: (identificationData) =>
    dispatch(requestOneUsersIdentification(identificationData)),

  requestProductosAllSearch: (search, clienteId, contactoId) =>
    dispatch(requestProductosAllSearch(search, clienteId, contactoId)),

  hasProyectByClienteId: (clienteId) =>
    dispatch(hasProyectByClienteId(clienteId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
